<template>
  <div>
    <!-- <div class="title" v-if="!is_superuser">{{ systemType }}</div> -->
    <label v-for="(item, index) in navMenus" :key="index">
      <el-menu-item :index="item.path" v-if="item.path != 'routerView' && !item.hidden">
        <h3>
          <div><i class="iconfont" :class="item.icon"></i>{{ item.name }}</div>
        </h3>
      </el-menu-item>
      <el-submenu :index="item.name" v-if="item.path == 'routerView' && !item.hidden">
        <template slot="title">
          <h3><i class="iconfont" :class="item.icon"></i>{{ item.name }}</h3>
        </template>
        <el-menu-item-group>
          <el-menu-item :index="citem.path" v-for="(citem, cindex) in item.children" :key="cindex">
            <div class="secondMenu" v-if="!citem.hidden">{{ citem.name }}</div>
          </el-menu-item>
        </el-menu-item-group>
      </el-submenu>
    </label>
  </div>
</template>
<script>
export default {
  name: "NavMenu",
  props: ["navMenus"],
  data() {
    return {
      // is_superuser: JSON.parse(sessionStorage.getItem("userinfo")).is_superuser,
      // systemType: sessionStorage.getItem(`systemName`),
    };
  },
  methods: {},
};
</script>
<style>
.title {
  font-size: 2em;
  color: white;
  text-align: center;
}
.iconfont {
  font-size: 26px !important;
}
.icon-jiankong-xianlupeizhi::before {
  font-size: 20px;
}
</style>
